import styled from 'styled-components';

export const Avatar = styled.div`
    display: flex;
    margin: ${({ margin }) => (margin ? margin : 'auto')};
    align-items: center;
    justify-content: center;
    /* margin: auto; */
    min-width: ${({ size }) => (size ? size + 'px' : null)};
    width: ${({ size }) => (size ? size + 'px' : null)};
    height: ${({ size }) => (size ? size + 'px' : null)};
    background-color: ${({ backgroundColor, bg, theme }) => {
        if (bg) return theme.color[bg];
        return backgroundColor;
    }};
    border: ${({ border }) => (border ? border : null)};
    border-radius: 50%;
    // Position
    position: ${({ position }) => (position ? position : null)};
    top: ${({ top }) => (top ? top : null)};
    right: ${({ right }) => (right ? right : null)};
    bottom: ${({ bottom }) => (bottom ? bottom : null)};
    left: ${({ left }) => (left ? left : null)};
    // Transform
    transform: ${({ transform }) => (transform ? transform : null)};
    // Other
    cursor: ${({ type }) => (type ? (type === 'button' ? 'pointer' : 'default') : null)};

    &:focus-visible {
        outline: none;
        border: 2px solid ${({ theme }) => theme.color['#A0DCFF']};
    }
`;